<template>
    <c-badge :color="color" :text-color="textColor">{{ role.localizedName.toUpperCase() }}</c-badge>
</template>
<script setup>
import { CBadge } from '@coreui/vue/dist/esm/components/badge/index.js';
import { computed } from 'vue';

const props = defineProps(['role']);
const color = computed(() => (props.role.name === 'admin' ? 'primary' : 'light'));
const textColor = computed(() => (props.role.name === 'admin' ? 'white' : 'body-emphasis'));
</script>
